import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';
import { ShowDeviceLogsResolver } from './support-device-logs/show-device-logs-resolver';

export class SupportRouteDefinition {
  public static getRoutes(): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.SUPPORT,
      resolver: AlwaysShowRouteResolver,
      title: 'Support',
      icon: 'icon-help.svg',
      position: 12,
      children: [
        {
          path: RoutePaths.DASHBOARD,
          parentPath: RoutePaths.SUPPORT,
          title: 'Support Dashboard',
          position: 1
        },
        {
          path: RoutePaths.VALIDATION,
          parentPath: RoutePaths.SUPPORT,
          title: 'Account Validation',
          position: 2
        },
        {
          path: RoutePaths.LOGS,
          parentPath: RoutePaths.SUPPORT,
          resolver: ShowDeviceLogsResolver,
          title: 'Device Logs',
          position: 3
        }
      ]
    };
    return menuItems;
  }
}
